import Vue from 'vue'
import RootMapBoxMixin from 'GroomyRoot/mixins/MapBox.js'

export default Vue.util.mergeOptions(RootMapBoxMixin, {

})